import { observer } from 'mobx-react-lite';
import { Form, Input, Select } from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import {
  cardCategoriesConfigDetails,
  cardConfigDetails,
  countConfigDetails,
} from '../fixture';
import './styles.css';

function Card() {
  // -------------------- Stores ------------------------ //
  const { DashboardConfigurationStore } = useStore();

  // -------------------- States ------------------------ //
  const { categories, data } = DashboardConfigurationStore.card;
  const { count, progress, status } = data || {};

  const categorieshandler = (_e: any, { value }: { value: string[] }) => {
    let list = ['count', 'progress', 'status'];

    let x = list?.filter((d) => !value.includes(d));

    x?.forEach((name) => {
      delete (DashboardConfigurationStore.card.data as any)?.[`${name}`];
    });
    DashboardConfigurationStore.card.categories = value;
  };

  return (
    <div style={{ marginTop: '16px' }}>
      <h4>Card Configuration</h4>
      <div className="cardCountWrapper">
        <Form.Field
          label={'Card Style'}
          control={Select}
          placeholder={'Select Card Style'}
          clearable
          fluid
          search
          selection
          options={cardConfigDetails}
          onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
            if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
              e.stopPropagation();
          }}
          style={{ marginTop: '5px' }}
          value={DashboardConfigurationStore.card.data?.style || ''}
          onChange={(_e: any, data: any) =>
            (DashboardConfigurationStore.card.data = {
              ...DashboardConfigurationStore.card.data,
              style: data.value,
            })
          }
        />
      </div>
      {DashboardConfigurationStore.card.data?.style !== 'style 2' && (
        <div className="cardTypeWrapper dashboardConfigWrapper">
          <Form.Field
            label={'Card Categories'}
            control={Select}
            placeholder={'Select Card Categories'}
            clearable
            fluid
            search
            selection
            multiple
            options={cardCategoriesConfigDetails}
            onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
              if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
                e.stopPropagation();
            }}
            style={{ marginTop: '5px' }}
            value={categories || []}
            onChange={categorieshandler}
          />
        </div>
      )}
      {(categories?.includes('count') ||
        DashboardConfigurationStore.card.data?.style === 'style 2') && (
        <div className="cardCountWrapper">
          <label>Count Properties</label>
          <Form.Field
            control={Select}
            placeholder={'Select Count Type'}
            clearable
            fluid
            search
            selection
            options={countConfigDetails}
            onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
              if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
                e.stopPropagation();
            }}
            style={{ marginTop: '5px' }}
            value={count}
            onChange={(_e: any, data: any) =>
              (DashboardConfigurationStore.card.data = {
                ...DashboardConfigurationStore.card.data,
                count: data.value,
              })
            }
          />
        </div>
      )}
      {DashboardConfigurationStore.card.data?.style !== 'style 2' &&
        categories?.includes('progress') && (
          <div className="cardProgressWrapper">
            <label>Progress Properties</label>
            <Form.Field
              control={Select}
              placeholder={'Select Progress Start'}
              clearable
              fluid
              search
              selection
              options={countConfigDetails}
              onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
                if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
                  e.stopPropagation();
              }}
              style={{ marginTop: '5px' }}
              value={progress?.start}
              onChange={(_e: any, data: any) =>
                (DashboardConfigurationStore.card.data = {
                  ...DashboardConfigurationStore.card.data,
                  progress: {
                    ...DashboardConfigurationStore.card.data.progress,
                    start: data.value,
                  } as any,
                })
              }
            />
            <Form.Field
              control={Select}
              placeholder={'Select Progress End'}
              clearable
              fluid
              search
              selection
              options={countConfigDetails}
              onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
                if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
                  e.stopPropagation();
              }}
              style={{ marginTop: '5px' }}
              value={progress?.end}
              onChange={(_e: any, data: any) =>
                (DashboardConfigurationStore.card.data = {
                  ...DashboardConfigurationStore.card.data,
                  progress: {
                    ...DashboardConfigurationStore.card.data.progress,
                    end: data.value,
                  } as any,
                })
              }
            />
          </div>
        )}
      {DashboardConfigurationStore.card.data?.style !== 'style 2' &&
        categories?.includes('status') && (
          <div className="cardStatusWrapper">
            <label>Status Properties</label>
            <Form.Field
              control={Input}
              placeholder={'This is message box...'}
              style={{ marginTop: '5px' }}
              value={status?.message}
              onChange={(_e: any, data: any) =>
                (DashboardConfigurationStore.card.data = {
                  ...DashboardConfigurationStore.card.data,
                  status: {
                    ...DashboardConfigurationStore.card.data.status,
                    message: data.value,
                  } as any,
                })
              }
            />
            <Form.Field
              control={Select}
              placeholder={'Select Count Type'}
              clearable
              fluid
              search
              selection
              options={countConfigDetails}
              onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
                if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
                  e.stopPropagation();
              }}
              style={{ marginTop: '5px' }}
              value={status?.count}
              onChange={(_e: any, data: any) =>
                (DashboardConfigurationStore.card.data = {
                  ...DashboardConfigurationStore.card.data,
                  status: {
                    ...DashboardConfigurationStore.card.data.status,
                    count: data.value,
                  } as any,
                })
              }
            />
          </div>
        )}
    </div>
  );
}

export default observer(Card);
